import axios from 'axios'

import { TranscriptMetadata } from 'src/models/TranscriptMetadata'
import { TranscriptCrdtTransportFatalError } from 'src/network/TranscriptCrdtTransport'

type InsightsFallbackEligibilityParams = {
    error: unknown
    metadata: TranscriptMetadata | null
}

const SLOT_ROUTE_SEGMENTS = ['/doc/', '/route']

export const isSlotRouteNotFoundError = (error: unknown) => {
    if (!axios.isAxiosError(error) || error.response?.status !== 404) {
        return false
    }

    const requestUrl = error.config?.url ?? ''

    return SLOT_ROUTE_SEGMENTS.every((segment) => requestUrl.includes(segment))
}

const isTransportNotFoundError = (error: unknown): boolean => {
    return error instanceof TranscriptCrdtTransportFatalError && error.errorType === 'not_found'
}

export const isInsightsFallbackEligible = ({ error, metadata }: InsightsFallbackEligibilityParams) => {
    if (metadata?.viewMode !== 'job') return false

    return isSlotRouteNotFoundError(error) || isTransportNotFoundError(error)
}
